import { useEffect, useState } from "react";
import { BlogCategory } from "../types";
import { Button, Card, Input, Textarea } from "@mantine/core";
import { makeGetRequest, makePostRequest, makePutRequest } from "../services/httpHelper";
import { isErrorObject } from "../utils/utils";
import ErrorHandler from "../services/ErrorHandler";



export default function BlogCategoryManager() {
  const [categories, setCategories] = useState<BlogCategory[]>([]);
  const [form, setForm] = useState({ id: "", category: "", description: "" });
  const [editing, setEditing] = useState(false);
const [error, setError] = useState<string | null>(null);
const [categoryId, setCategoryId] = useState<string | null>(null);

  

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };


  const handleSubmit = async() => {


    if (!form.category || !form.description) return alert("All fields are required");

    if (editing) {
        const response = await makePutRequest(`blog-post-category/${categoryId}`, {category:form.category,description:form.description});

        if (isErrorObject(response)) {
          const errorMessage = ErrorHandler(response);
          setError(errorMessage);
          console.log(error)
      }else{
        setCategories(categories.map(cat => (cat.id === form.id ? { ...form } : cat)));
        setEditing(false);
        fetchCategories();
        alert('Record updated!')
      } 

     
    } else {

        const response = await makePostRequest('blog-post-category', {category:form.category,description:form.description});

        if (isErrorObject(response)) {
          const errorMessage = ErrorHandler(response);
          setError(errorMessage);
          console.log(error)
      } 
      setCategories([...categories, { ...form, id: Date.now().toString() }]);
      alert('Category added!')
    }

    setForm({ id: "", category: "", description: "" });
  };

  const handleEdit = async(category: BlogCategory) => {
    setForm(category);
    setCategoryId(category.id)
    setEditing(true);



  };

  const handleDelete = async(id: string) => {
    alert(id)

    const response = await makePutRequest(`remove-blog-post-category/${id}`,{});

    if (isErrorObject(response)) {
      const errorMessage = ErrorHandler(response);
      setError(errorMessage);
      console.log(error)
  }else{
    setCategories(categories.filter(cat => cat.id !== id));
    alert('Category removed')

  } 


  };

  const fetchCategories = async () => {
    const res = await makeGetRequest('blog-post-categories');      
    if (isErrorObject(res)) {
      const errorMessage = ErrorHandler(res);
      setError(errorMessage);
      console.log(error)
  } else {
    setCategories(res.data);
      setError(null);
  }


   
  };

  useEffect(()=>{
   
      fetchCategories();
  },[])

  return (
    <div className="p-4 max-w-2xl mx-auto">
      <Card shadow="sm" padding="lg">
          <Input placeholder="Category Name" name="category" value={form.category} onChange={handleChange} />
          <Textarea placeholder="Description" name="description" value={form.description} onChange={handleChange} />
          <Button onClick={handleSubmit}>{editing ? "Update Category" : "Add Category"}</Button>
      </Card>
      <div className="mt-6">
        <h2 className="text-lg font-semibold mb-2">Categories</h2>
        <ul className="space-y-2">
          {categories.map(cat => (
            <li key={cat.id} className="flex justify-between items-center p-2 border rounded-md">
              <div>
                <p className="font-medium">{cat.category}</p>
                <p className="text-sm text-gray-600">{cat.description}</p>
              </div>
              <div className="space-x-2">
                <Button size="sm" onClick={() => handleEdit(cat)}>Edit</Button>
                <Button size="sm" variant="destructive" onClick={() => handleDelete(cat.id)}>Delete</Button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}